import PageHero from "@/components/shared/PageHero";
import ProvenResultsSection from "@/components/sections/ProvenResultsSection";
import CTASection from "@/components/sections/CTASection";
import { ASSETS, BRAND } from "@/lib/brand";

export default function ProvenResultsPage() {
  return (
    <div data-testid="page-proven-results">
      <PageHero
        eyebrow="Proven Results"
        title={<>Outcomes that <span className="italic text-bronze">speak for themselves.</span></>}
        sub="Real case studies from real Singapore families — sold faster, sold higher, and upgraded with confidence."
        image={ASSETS.lifestyle.livingRoom}
        ctas={[
          { label: "Get Valuation", href: BRAND.valuationLink, variant: "primary" },
          { label: "Read Testimonials", to: "/success-stories/testimonials", variant: "secondary" },
        ]}
      />
      <ProvenResultsSection withHeading={false} />
      <CTASection />
    </div>
  );
}
